export {
  PhotoCaptureHUDElementsAddDamage1stShot,
  type PhotoCaptureHUDElementsAddDamage1stShotProps,
} from './PhotoCaptureHUDElementsAddDamage1stShot';
